export const SET_REVIEW_DATA = 'SET_REVIEW_DATA';
export const FETCHING_REVIEW_DATA = 'FETCHING_REVIEW_DATA';
export const FETCHING_REVIEW_DATA_BACKGROUND =
  'FETCHING_REVIEW_DATA_BACKGROUND';
export const SET_REVIEW_DATA_COUNT = 'SET_REVIEW_DATA_COUNT';
export const RESET_REVIEW_DATA = 'RESET_REVIEW_DATA';
export const SET_UPLOAD_SESSION_ID = 'SET_UPLOAD_SESSION_ID';
export const SET_PARAMS = 'SET_PARAMS';
export const UPDATE_REVIEW_DATA = 'UPDATE_REVIEW_DATA';
export const SET_REVIEW_DATA_NEXT_API = 'SET_REVIEW_DATA_NEXT_API';
export const SET_REVIEW_IMAGE_POSITIVE_COUNT =
  'SET_REVIEW_IMAGE_POSITIVE_COUNT';
export const SET_REVIEW_DEFECTS = 'SET_REVIEW_DEFECTS';
export const CLEAR_REVIEW_DEFECTS = 'CLEAR_REVIEW_DEFECTS';
export const SET_FILE_SET_DEFECTS_LOADING = 'SET_FILE_SET_DEFECTS_LOADING';
export const REMOVE_FILE_SET_BY_IDS = 'REMOVE_FILE_SET_BY_IDS';
export const UPDATE_IMAGE_MODES = 'UPDATE_IMAGE_MODES';
export const SET_FILE_SET_DEFECTS_BY_ID = 'SET_FILE_SET_DEFECTS_BY_ID';
export const SET_USER_CLASSIFICATION = 'SET_USER_CLASSIFICATION';
export const UPDATE_USER_CLASSIFICATION_BY_ID =
  'UPDATE_USER_CLASSIFICATION_BY_ID';
export const CLEAR_USER_CLASSIFICATION = 'CLEAR_USER_CLASSIFICATION';
export const SET_SELECTED_TOOL = 'SET_SELECTED_TOOL';
export const SET_ANNOTATOR_INPUT = 'SET_ANNOTATOR_INPUT';
export const SET_APPLIED_FOR_ALL_MODEL_ID = 'SET_APPLIED_FOR_ALL_MODEL_ID';
export const SET_USE_AI_ASSISTANCE = 'SET_USE_AI_ASSISTANCE';
export const SET_MODEL_OUTPUT_LIST = 'SET_MODEL_OUTPUT_LIST';
export const SET_MODEL_DETECTION_LIST = 'SET_MODEL_DETECTION_LIST';
export const SET_USER_DETECTION_LIST = 'SET_USER_DETECTION_LIST';
export const SET_REVIEW_MODEL_DICT = 'SET_REVIEW_MODEL_DICT';
export const SET_AI_DEFECTS = 'SET_AI_DEFECTS';
export const CLEAR_AI_DEFECTS = 'CLEAR_AI_DEFECTS';
export const SET_TASK_ID = 'SET_TASK_ID';
export const UPDATE_FILESET_BY_ID = 'UPDATE_FILESET_BY_ID';
export const UPDATE_FILESET_TAGS_BY_ID = 'UPDATE_FILESET_TAGS_BY_ID';

export const SET_ACTIVE_GRID_MODE = 'SET_ACTIVE_GRID_MODE';
export const SET_IMAGE_MODES = 'SET_IMAGE_MODES';
export const SET_ACTIVE_IMAGE_MODE = 'SET_ACTIVE_IMAGE_MODE';
export const SET_ACTIVE_IMG = 'SET_ACTIVE_IMG';

export const ScratchAIAnnotation = 'scratch-ai-annotation';
export const GroundTruthCorrection = 'ground-truth-correction';
export const GeneralViewing = 'general-viewing';
export const ReviewerAnnotation = 'reviewer-annotation';

export const Review = 'review';
export const AUDIT = 'audit';
export const CLUSTERING = 'clustering';
export const MANUAL_CLASSIFY = 'manual-classify';

export const SET_OTHER_DEFECTS = 'SET_OTHER_DEFECTS';
export const SET_SELECT_ALL = 'SET_SELECT_ALL';

export const SET_CONTAINER_META = 'SET_CONTAINER_META';

export const INFERENCE_STATUS = {
  PENDING: 'In Progress',
  PROCESSING: 'In Progress',
  FINISHED: 'Inference Complete',
};

export const REMOVE_GT_DEFECT = 'REMOVE_GT_DEFECT';
export const SET_BULK_CLASSIFICATION_UPDATING =
  'SET_BULK_CLASSIFICATION_UPDATING';

export const SET_CURRENT_FILE_SIZE = 'SET_CURRENT_FILE_SIZE';

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export const SORTING_CONSTANTS = {
  AI_OUTPUT: 'ai_output',
  GROUND_TRUTH: 'files__gt_classifications__defects__name',
  CREATED_DATE: 'created_ts',
  SIMILARITY: 'defect_similarity',
};

export const SET_SELECT_WAFER_DOTS = 'SET_SELECT_WAFER_DOTS';
export const TOGGLE_MARK_IMAGE_CENTER = 'TOGGLE_MARK_IMAGE_CENTER';

export const SET_DEFECT_COLOR_CODES = 'SET_DEFECT_COLOR_CODES';

export const IRR_FROM_SESSION_STORAGE = 'IRR_FROM_SESSION_STORAGE';

export const SET_FILESET_DELETING = 'SET_FILESET_DELETING';

export const UPDATE_TRANSFERABLE_IMAGE_INDEXES =
  'UPDATE_TRANSFERABLE_IMAGE_INDEXES';

export const UPDATE_TRANSFER_IMAGE_INDEXES = 'UPDATE_TRANSFER_IMAGE_INDEXES';

export const UPDATE_ACTIVE_IMAGE = 'UPDATE_ACTIVE_IMAGE';

export const SET_FILE_SET_LOCAL_DEFECTS = 'SET_FILE_SET_LOCAL_DEFECTS';
export const SET_BULK_FILE_SET_LOCAL_DEFECTS =
  'SET_BULK_FILE_SET_LOCAL_DEFECTS';
export const RESET_FILE_SET_LOCAL_DEFECTS = 'RESET_FILE_SET_LOCAL_DEFECTS';

export const SET_FILE_SET_LOCAL_DEFECTS_SAVING_STATUS =
  'SET_FILE_SET_LOCAL_DEFECTS_SAVING_STATUS';

export const UPDATE_IRR = 'UPDATE_IRR';
export const TOGGLE_IRR = 'TOGGLE_IRR';
export const SET_IRR_LOADING = 'SET_IRR_LOADING';

export const SET_IS_UPLOAD_SESSION_LIVE = 'SET_IS_UPLOAD_SESSION_IS_LIVE';

export const SET_DISABLE_HOTKEYS = 'SET_DISABLE_HOTKEYS';

export const SET_FILESET_TAGS = 'SET_FILESET_TAGS';

export const ADD_FILESET_TAGS = 'ADD_FILESET_TAGS';

export const activeImageModeStatusMap = {
  Audited: 'audited',
  Unaudited: 'unaudited',
  Classified: 'classified',
  Unclassified: 'unclassified',
};

export const fileSetLocalDefectsStatus = {
  LOADING: 'LOADING',
  NONE: 'NONE',
  ERROR: 'ERROR',
};

export const SET_USE_CASE_ID = 'SET_USE_CASE_ID';

export const SET_SELECT_CLUSTER_RECTANGLE = 'SET_SELECT_CLUSTER_RECTANGLE';
